import React, {useEffect, useState } from "react";
import { getAllOutsourcedStaffs, sendAllDocuments } from "../../utils/helper";
import Loader from "../../utils/Loader";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { alertSuccess, alertError } from "../../utils/alerts";

export default function OnboardEmployees() {
    const [loading, setLoading] = useState(false);
    const [staffs, setAllOutsourcedStaffs] = useState(null);
    const [userIds, setUserIds] = useState([]);
    const [docLoading, setDocLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        getAllOutsourcedStaffs()
            .then((res) => { 
                setAllOutsourcedStaffs(res.data.data);  
                setTimeout(() => {
                    setLoading(false)
                }, 3500);
            })
            .catch((err) => {
                console.log(err?.response)
                setTimeout(() => {
                    setLoading(false)
                }, 3500);
            });
    }, []);

    const isSelected = (id) => userIds.length > 0 && userIds.indexOf(id) !== -1;
    
    const handleSelectId = (e, id) => {
        e.persist();
        setUserIds((prev) =>
          e.target.checked === false && prev.includes(id)
            ? prev.filter((acc) => acc !== id)
            : [...prev, id]
        );
    };

    const handleShareDocuments = async (e) => {
        e.preventDefault();
        if (window.confirm("Note: Are you sure you want to proceed? Click OK to proceed.")) {
            const data = { userIds };
            if(data.userIds.length > 0){
                setDocLoading(true);
                sendAllDocuments(data)
                .then((res) => {
                    if(res.data.success){
                        alertSuccess(res.data.message)
                        setTimeout(() => {
                            window.location.reload()
                        }, 2500);
                    } else {
                        alertError(res.data.message)
                    }
                    setDocLoading(false);
                })
                .catch((err) => {
                    console.log(err.response)
                    alertError(err.response?.data?.error);
                    setDocLoading(false);
                });
            };
        } else {alert("Document sharing was canceled!");}
    }

    return (
        <>
            <h1 className="dash-title"><Link to="/outsourcing/onboarding" style={{color: '#454545'}}>
                <i className="fa fa-arrow-left"></i> Go Back</Link>
            </h1>

            <div className="row dash-row">
                
                <div className="col-md-12 col-sm-12 col-12">
                    <div className="card spur-card" style={{marginTop: 5}}>
                        <div className="card-header">
                            <div className="spur-card-title">Onboard New Employees</div>
                            {userIds.length > 0 && (
                            <div className="spur-card-menu">
                                <button 
                                    onClick={handleShareDocuments}
                                    style={{backgroundColor:"#fcce0d", color:"#444", border:'1px solid #fcce0d', fontWeight:'bold'}} 
                                    type="button" 
                                    className="pull-right btn topbtn btn-primary"
                                    disabled={docLoading}
                                >
                                    Send Onboarding Docs
                                </button>
                            </div> 
                            )}
                        </div>
                        <div className="card-body">
                            <div className="my_profile">
                                {(!loading && staffs && staffs) ? 
                                    <div className="table-responsive">
                                        {(staffs && staffs.length > 0) ?
                                        <table className="table text-left text-caps table-bordered" id="myTable">
                                            <thead><tr><th>SN</th><th>Tick</th><th>Name</th><th>Email</th><th>Organization</th><th>Staff ID</th><th>Job Title</th>
                                            <th>Status</th></tr></thead>
                                            <tbody>
                                                {staffs && staffs.map((row, index) => {
                                                    const isItemSelected = isSelected(row._id);

                                                    return (
                                                        <tr key={index}>
                                                            <td>{index + 1}</td>
                                                            <td><label className="ccbox">
                                                                <input 
                                                                    type="checkbox" 
                                                                    onChange={(e) => handleSelectId(e, row._id)}
                                                                    checked={isItemSelected}
                                                                    disabled={(row.status !== "new") || docLoading}
                                                                />
                                                                <span className="checkmark"></span>
                                                                </label>
                                                            </td>
                                                            <td>{row?.first_name && row?.first_name} {row?.last_name && row?.last_name}</td>
                                                            <td>{row?.email && row?.email}</td>
                                                            <td>{row?.organization?.name && row?.organization?.name}</td>
                                                            <td>{row?.staff_id && row?.staff_id}</td>
                                                            <td>{row?.job_role?.name && row?.job_role?.name}</td> 
                                                            <td>{row?.status === "new" ? 
                                                            <span className="badge badge-danger">{row.status}</span> : 
                                                            <span className="badge badge-warning">{row.status}</span>}</td>
                                                        </tr>
                                                    )
                                                }
                                                )}
                                            </tbody>
                                        </table> : 
                                        <div className="alert alert-danger myerror d-block">No record found.</div> }
                                    </div>
                                : <Loader /> }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
